import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getRaleighStructuredData() {
  const url = "https://restorehair.com/locations/north-carolina/raleigh/";
  const description =
    "Find out about your hair transplant options in Raleigh with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("raleigh", url, description),
    locationPageCrumbs(url, "Raleigh"),
  ];
}
